import {
  ShouldPushToDataLayerObject,
  TrackingClientStateHolder,
} from '@aboutyou/legacy-tracking-sdk';
import {useBasketStateBasketKey, useCustomerId} from '@aboutyou/user';
import React, {FC, memo, useEffect} from 'react';
import {useTracking} from '../utils/utils';

const TrackBeginCheckout: FC<{device: string}> = ({device}) => {
  if (!process.browser) {
    return null;
  }

  return <StartBeginCheckoutTracking device={device} />;
};

const StartBeginCheckoutTracking = ({device}: {device: string}) => {
  useTrackBeginCheckout(device);
  return null;
};

const useTrackBeginCheckout = (device: string) => {
  const {TrackingClient} = useTracking();
  const userId = useCustomerId();
  const basketKey = useBasketStateBasketKey();

  useEffect(() => {
    if (userId || basketKey) {
      TrackingClient.trackWithoutPushToDataLayer(
        triggerTrackingBeginCheckout(
          userId,
          device === 'android' || device === 'ios' ? 'app' : 'web',
          basketKey,
        ),
      );
    }
  }, [TrackingClient, userId, basketKey]);
};

const triggerTrackingBeginCheckout =
  (userId: number | null, platform: 'web' | 'app', basketKey?: string) =>
  (state: TrackingClientStateHolder): ShouldPushToDataLayerObject => {
    const currentState = state.getCurrent();

    const [language, countryCode] = currentState.locale!.split('_');
    let gtmVersion = 'unknown';
    document.querySelectorAll('script').forEach(item => {
      if (item.src.includes('gtm.js')) {
        gtmVersion = item.src.split('gtm.js?id=')[1]!;
      }
    });

    const body = JSON.stringify({
      eventName: 'begin_checkout',
      context: {
        shop: {
          country: countryCode,
          currency: currentState.currency,
          id: currentState.shop.shopId,
          language,
          version: currentState.shop.appVersion,
          versionGitHash: currentState.shop.gitHash,
          cookies: decodeURIComponent(document.cookie.toString()),
        },
        libraries: {
          gtmVersion,
        },
        device: {
          platform,
        },
        user: {
          id: userId ? userId.toString() : null,
          basketKey: basketKey || null,
        },
      },
    });

    fetch('https://tapi-ua67xpa5cq-ey.a.run.app/events', {
      credentials: 'include',
      method: 'POST',
      body,
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'x-tapi-version': '2.0.0',
      },
    });

    return undefined;
  };

const MemoizedTrackBeginCheckout = memo(TrackBeginCheckout);

export {MemoizedTrackBeginCheckout as TrackBeginCheckout};
